import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import DefaultLayout from '../Layout/AppMain';
import AuthLayout from '../Layout/AppAuth';

import { useAuth } from '../Context/Auth/AuthContext';

import { createBrowserHistory } from 'history';
import ReactGA from 'react-ga';
import Maintenance from '../pages/Maintenance/index';

const enabledGA = process.env.REACT_APP_GOOGLE_ANALYTICS_ENABLED;
if (enabledGA === 'true') {
    const history = createBrowserHistory();

    history.listen(location => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
    });
}

export default function RouteWrapper({
    component: Component,
    isPrivate,
    isInvite,
    ...rest
}) {
    const { authenticated, loadAccessibilityScript, loadFontSize } = useAuth();
    loadFontSize();

    // const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE;
    const maintenanceMode = document.SENIOR_LINK_MAINTENANCE;
    if (maintenanceMode !== undefined && maintenanceMode === true) {
        return (
            <Route
                {...rest}
                render={() => (
                    <AuthLayout>
                        <Maintenance />
                    </AuthLayout>
                )}
            />
        )
    }

    let signed = null;
    if (authenticated) {
        signed = true;
    } else {
        signed = false;
    }    
    if (!signed && isPrivate) {
        return <Redirect to="/" />;
    }

    if (signed && !isPrivate && !isInvite) {
        return <Redirect to="/groups" />;
    }

    const Layout = signed && !isInvite ? DefaultLayout : AuthLayout;

    try {
        const enabledAccessibility = process.env.REACT_APP_ACCESSIBILITY_SCRIPT_ENABLED;
        if (enabledAccessibility === 'true') {
            loadAccessibilityScript();
        }
    } catch(err) {
        console.error(err);
    }

    return (
        <Route
            {...rest}
            render={(props) => (
                <Layout>
                    <Component {...props} />
                </Layout>
            )}
        />
    );
}

RouteWrapper.propTypes = {
    isPrivate: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
        .isRequired,
};

RouteWrapper.defaultProps = {
    isPrivate: false,
};
